import { render, staticRenderFns } from "./WitnessTimeList.vue?vue&type=template&id=3da4f5be&"
import script from "./WitnessTimeList.vue?vue&type=script&lang=js&"
export * from "./WitnessTimeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports